import goldenKeyClub from "../images/extra_curriculars/goldenKeyClub.png";
import McHacksPic from "../images/extra_curriculars/McHacks.png";
import BikingAdventuresPic from "../images/extra_curriculars/TheBikingAdventures.png";
import TAMIDpic from "../images/extra_curriculars/TAMID.png";
import MAISHacksPic from "../images/extra_curriculars/maisHacks.png";

const extraCurriculars = [
  {
    title: "TAMID Tech Track",
    dates: "Technical Director",
    link: "https://tamidgroup.org/",
    img_path: TAMIDpic,
  },
  {
    title: "The Biking Adventures",
    dates: "Co-Founder",
    link: "https://www.facebook.com/TheBikingAdventures",
    img_path: BikingAdventuresPic,
  },
  {
    title: "MAIS Hacks",
    dates: "Participant",
    link: "https://devpost.com/software/roast-generator?ref_content=my-projects-tab&ref_feature=my_projects",
    img_path: MAISHacksPic,
  },
  {
    title: "McHacks",
    dates: "Participant",
    link: "https://youtu.be/t-ToQBkY5Mc",
    img_path: McHacksPic,
  },
  {
    title: "Golden Key Club",
    dates: "Member",
    link: "https://www.mcgill.ca/deanofstudents/students/recognition/golden-key-honour-society",
    img_path: goldenKeyClub,
  },
];

export default extraCurriculars;
